<template>
    <rkm-row>
        <rkm-col cols="2">
            <rkm-form-input
                :validations="validations.numero"
                label="Número"
                v-model="model.documentos.carteiraTrabalho.numero"
                uppercase
            />
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-input
                :validations="validations.serie"
                label="Série"
                v-model="model.documentos.carteiraTrabalho.serie"
                :disabled="!model.documentos.carteiraTrabalho.numero"
                uppercase
            />
        </rkm-col>

        <rkm-col cols="3">
            <rkm-form-date-picker
                :validations="validations.dataEmissao"
                label="Data de emissão"
                v-model="model.documentos.carteiraTrabalho.dataEmissao"
                :disabled="!model.documentos.carteiraTrabalho.numero"
                :min-date="getDataNascimentoString()"
                :max-date="dataAtual"
            />
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-select
                :options="form.estados"
                label="UF"
                text-field="uf"
                v-model="model.documentos.carteiraTrabalho.estadoId"
                value-field="id"
                :validations="validations.estado"
                :disabled="!model.documentos.carteiraTrabalho.numero"
                show-default-option
            />
        </rkm-col>

        <rkm-col cols="3">
            <rkm-form-input
                :validations="validations.nisPisPasep"
                label="PIS / PASEP | NIS"
                v-model="model.documentos.carteiraTrabalho.nisPisPasep"
                number
            />
        </rkm-col>
    </rkm-row>
</template>

<script>
// Moment.
import moment from 'moment'

export default {
    props: {
        dataAtual: { type: String, required: true },
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    computed: {
        validations() {

            return {
                numero: {
                    min: 7,
                    max: 16
                },
                serie: {
                    required: !!this.model.documentos.carteiraTrabalho.numero,
                    min: 5,
                    max: 5
                },
                dataEmissao: {
                    required: !!this.model.documentos.carteiraTrabalho.numero,
                },
                estado: {
                    required: !!this.model.documentos.carteiraTrabalho.numero,
                },
                nisPisPasep: {
                    min: 11,
                    max: 11,
                    nis_pis_pasep: true,
                }
            }
        }
    },
    watch: {
        'model.documentos.carteiraTrabalho.numero': function (numero) {

            if (!numero) {

                this.model.documentos.carteiraTrabalho.serie = ''
                this.model.documentos.carteiraTrabalho.dataEmissao = null
                this.model.documentos.carteiraTrabalho.estadoId = null
                this.model.documentos.carteiraTrabalho.nisPisPasep = ''
            }
        }
    },
    methods: {
        getDataNascimentoString() {

            return this.model.dataNascimento
                ? moment(this.model.dataNascimento).format('DD/MM/YYYY')
                : null
        },
    },
}
</script>